module.exports = __webpack_public_path__ + "media/components/assets/recycling_03-0e8371d43b49e3123ce42f9174874b74.jpg";